import { useGetResolvedFlagsQuery } from '../store/api/featureFlagsApi';

/**
 * Devuelve si una feature flag está habilitada para el usuario actual.
 * Mientras carga, devuelve `true` (fail-open) para no parpadear la UI.
 * Si no existe la key en la base, devuelve `true` (flag no configurado = visible).
 */
export function useFeatureFlag(key: string | undefined): boolean {
  const { data, isLoading } = useGetResolvedFlagsQuery();
  if (!key) return true;
  if (isLoading || !data) return true;
  if (!(key in data)) return true;
  return data[key];
}

export function useFeatureFlags(): { flags: Record<string, boolean>; isLoading: boolean } {
  const { data = {}, isLoading } = useGetResolvedFlagsQuery();
  return { flags: data, isLoading };
}

/**
 * Como `useFeatureFlag` pero falla CERRADO: mientras carga, si la key no existe o si no te
 * incluye, `false`. Para features que no pueden quedar a la vista de la red por un flag sin
 * sembrar (ver reference_flag_no_sembrada_fail_open), como las llamadas del chat.
 */
export function useFlagEstricta(key: string): boolean {
  const { data } = useGetResolvedFlagsQuery();
  return data?.[key] === true;
}
